module.exports = __webpack_public_path__ + "static/media/example.b29752b2.png";